<template>
  <TemplateView>
    <div class="container">
      <div class="d-flex flex-wrap mb-8">
        <BaseButton
          :text="page.text"
          style-type="chip"
          v-for="(page, p) in list"
          :key="'settingCompany' + p"
          :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
          @click="$router.push({ name: page.toName })"
        />
      </div>
      <router-view />
    </div>
  </TemplateView>
</template>

<script>
export default {
  name: "settingFinance",
  computed: {
    list() {
      return [
        {
          toName: 'SettingFinance',
          text: this.localStorage.translations.pages['setting'].pages['finance-vat-code'],
          if: true,
        },
        {
          toName: 'SettingFinanceTermsOfPayment',
          text: this.localStorage.translations.pages['setting'].pages['finance-terms-of-payment'],
          if: true,
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>